/* eslint-disable require-jsdoc */

export function flatten(data) {
    const rv = {};

    // eslint-disable-next-line prefer-const
    for (let prop1 in data) {
        if (!data.hasOwnProperty(prop1)) continue;

        // eslint-disable-next-line security/detect-object-injection
        if ((typeof data[prop1]) === 'object' && data[prop1] != null) {
            // eslint-disable-next-line security/detect-object-injection
            const flatObject = flatten(data[prop1]);
            // eslint-disable-next-line prefer-const
            for (let prop2 in flatObject) {
                if (!flatObject.hasOwnProperty(prop2)) continue;

                // eslint-disable-next-line security/detect-object-injection
                rv[prop1 + '.' + prop2] = flatObject[prop2];
            }
        } else {
            // eslint-disable-next-line security/detect-object-injection
            rv[prop1] = data[prop1];
        }
    }

    return rv;
}

export function unflatten(data, splitter = '.') {
    const rv = {};

    // eslint-disable-next-line guard-for-in, prefer-const
    for (let i in data) {
        const keys = i.split(splitter);
        keys.reduce(function(r, e, j) {
            // eslint-disable-next-line security/detect-object-injection
            return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 == j ? data[i] : {}) : []);
        }, rv);
    }

    return rv;
}
